import React from "react";
import "./NewPageBlock13.scss";
import { Image, Link, LinkBox, LinkOverlay, Text } from "@chakra-ui/react";

const socialIcons = [
  {
    id: 1,
    link: "https://www.youtube.com/channel/UCZlFmJ-8aj_wch2T2CWoe8w",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.208 11.688L10.708 8.68799C10.6516 8.65034 10.5859 8.62872 10.5181 8.62544C10.4503 8.62216 10.3829 8.63734 10.3231 8.66936C10.2632 8.70139 10.2132 8.74906 10.1783 8.80729C10.1434 8.86551 10.125 8.93212 10.125 8.99999V15C10.125 15.0679 10.1434 15.1345 10.1783 15.1927C10.2132 15.2509 10.2632 15.2986 10.3231 15.3306C10.3829 15.3626 10.4503 15.3778 10.5181 15.3745C10.5859 15.3713 10.6516 15.3496 10.708 15.312L15.208 12.312C15.2594 12.2777 15.3015 12.2314 15.3306 12.1769C15.3598 12.1225 15.375 12.0617 15.375 12C15.375 11.9383 15.3598 11.8775 15.3306 11.8231C15.3015 11.7686 15.2594 11.7222 15.208 11.688ZM10.875 14.2993V9.70068L14.3241 12L10.875 14.2993ZM21.6056 6.63805C21.5318 6.35075 21.3906 6.08513 21.1939 5.86312C20.9971 5.64111 20.7504 5.46906 20.4741 5.36118C17.3061 4.14365 12.213 4.16221 12.0023 4.16324C11.7873 4.16202 6.69403 4.14355 3.52584 5.36109C3.24954 5.46899 3.00286 5.64105 2.80614 5.86306C2.60943 6.08507 2.46832 6.35068 2.39447 6.63796C2.15747 7.54771 1.875 9.21656 1.875 12C1.875 14.7835 2.15747 16.4523 2.39438 17.362C2.46825 17.6493 2.60938 17.9149 2.80613 18.137C3.00288 18.359 3.2496 18.531 3.52594 18.6389C6.69394 19.8563 11.787 19.838 11.9977 19.8367C12.0082 19.8367 12.0305 19.8369 12.0639 19.8369C12.7092 19.8369 17.4618 19.7965 20.4742 18.6389C20.7505 18.531 20.9971 18.3589 21.1939 18.1369C21.3906 17.9149 21.5317 17.6493 21.6055 17.362C21.8425 16.4523 22.125 14.7834 22.125 12C22.125 9.21646 21.8425 7.5478 21.6056 6.63805ZM20.8798 17.173C20.8361 17.345 20.7521 17.5041 20.6348 17.6373C20.5175 17.7704 20.3702 17.8738 20.2051 17.9388C17.17 19.1051 12.0539 19.0876 11.9977 19.0867C11.9461 19.0867 6.82997 19.1051 3.79491 17.9388C3.62979 17.8737 3.48249 17.7704 3.36518 17.6372C3.24786 17.5041 3.16389 17.3449 3.12019 17.1729C2.89425 16.3056 2.625 14.7041 2.625 12C2.625 9.29596 2.89434 7.69434 3.12019 6.82696C3.16389 6.65497 3.24786 6.49584 3.36518 6.3627C3.48249 6.22956 3.62979 6.12622 3.79491 6.06121C6.83006 4.89487 11.9463 4.91343 12.0023 4.91324C12.0535 4.91259 17.17 4.89477 20.2051 6.06121C20.3702 6.12624 20.5175 6.2296 20.6348 6.36276C20.7521 6.49591 20.8361 6.65506 20.8798 6.82705C21.1057 7.69434 21.375 9.29587 21.375 12C21.375 14.704 21.1057 16.3056 20.8798 17.173Z"
          fill="black"
        />
      </svg>
    ),
  },
  {
    id: 2,
    link: "https://t.me/alexander_visotsky",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21.9628 2.73935C21.8981 2.68345 21.8194 2.6463 21.7351 2.63192C21.6508 2.61754 21.5642 2.62649 21.4847 2.65779L2.48531 10.0931C2.29163 10.1683 2.12763 10.3044 2.01804 10.4809C1.90844 10.6574 1.85919 10.8647 1.87771 11.0717C1.89622 11.2786 1.9815 11.4739 2.12068 11.6282C2.25987 11.7824 2.44542 11.8872 2.64937 11.9268L7.875 12.9525V18.75C7.87497 18.9743 7.94198 19.1935 8.06744 19.3794C8.19289 19.5653 8.37106 19.7095 8.57906 19.7934C8.71291 19.8471 8.85578 19.8748 9 19.875C9.15096 19.8746 9.3003 19.8439 9.43914 19.7846C9.57797 19.7254 9.70346 19.6388 9.80812 19.53L12.4331 16.8112L16.4644 20.3465C16.6687 20.5268 16.9316 20.6267 17.2041 20.6278C17.3231 20.6273 17.4413 20.6087 17.5547 20.5725C17.7403 20.5137 17.9072 20.4073 18.0388 20.2639C18.1704 20.1204 18.2621 19.9449 18.3047 19.755L22.1128 3.19872C22.1319 3.11575 22.128 3.02915 22.1016 2.94822C22.0751 2.86728 22.0272 2.79508 21.9628 2.73935ZM2.625 11.0043C2.6195 10.959 2.62972 10.9131 2.65394 10.8744C2.67817 10.8357 2.71494 10.8064 2.75812 10.7915L19.1316 4.38372L8.16281 12.2447L2.79469 11.1909C2.74919 11.1842 2.70741 11.162 2.67646 11.128C2.64552 11.094 2.62733 11.0503 2.625 11.0043ZM9.26906 19.0087C9.21722 19.0621 9.15065 19.0989 9.07784 19.1144C9.00503 19.1298 8.92926 19.1232 8.8602 19.0955C8.79113 19.0677 8.73188 19.0201 8.69 18.9585C8.64811 18.897 8.62549 18.8244 8.625 18.75V13.4718L11.8669 16.3125L9.26906 19.0087ZM17.5734 19.5843C17.5589 19.648 17.5281 19.7068 17.4839 19.7548C17.4397 19.8029 17.3837 19.8386 17.3215 19.8584C17.2593 19.8782 17.193 19.8814 17.1291 19.8677C17.0653 19.854 17.0061 19.8239 16.9575 19.7803L8.85281 12.6731L21.1997 3.82497L17.5734 19.5843Z"
          fill="black"
        />
      </svg>
    ),
  },
];

export function NewPageBlock13() {
  return (
    <div id="indexPageContactsBlockToScroll" className="landingPageBlock13 __block-wrapper">
      <div className="__block-container">
        <div className="d-flex flex-column">
          <Image className="__logo" src="/images/logo-sign.png" />
          <Text fontSize="14px">All rights reserved, 2021 - {new Date().getFullYear()}.</Text>
        </div>
        <div className="__info_block d-stack-row spacing-12">
          <div className="d-stack-column spacing-2">
            <div className="d-stack-column spacing-2">
              <Text fontSize="14px" fontWeight={700}>
                E-mail
              </Text>
              <Link
                style={{ fontSize: "14px" }}
                href="mailto:support@bbooster.online"
                children="support@bbooster.online"
              />
              {/*<Text fontSize="14px">support@bbooster.online</Text>*/}
            </div>
            <div className="d-stack-column spacing-2">
              <Text fontSize="14px" fontWeight={700}>
                Links
              </Text>
              {/*<Link href="support@bbooster.online" children="support@bbooster.online" />*/}
              <Link isExternal style={{ fontSize: "14px" }} href="/doc/privacy-policy" children="Privacy Policy" />
              <Link isExternal style={{ fontSize: "14px" }} href="/doc/terms-of-use" children="Terms of Use" />
              <Link
                isExternal
                style={{ fontSize: "14px" }}
                href="/doc/terms-of-payment-and-refunds"
                children="Terms of payment and refunds"
              />
              <Link
                isExternal
                style={{ fontSize: "14px" }}
                href="/doc/personal-data-processing-agreement"
                children="Personal Data Processing Agreement"
              />
              <Link isExternal style={{ fontSize: "14px" }} href="/doc/cookies-policy" children="Cookies Policy" />
            </div>
          </div>
          <div className="d-stack-column spacing-2">
            <Text fontSize="14px" fontWeight={700}>
              Contact phone number
            </Text>
            <Link style={{ fontSize: "14px" }} href="tel:+16468786047" children="+1 (646) 878-60-47" />
            {/*<Text fontSize="14px">+1 (646) 878-60-47</Text>*/}
          </div>
          <div className="d-stack-column spacing-2">
            <Text fontSize="14px" fontWeight={700}>
              Our social networks
            </Text>
            <div className="d-stack-row spacing-2 align-center">
              {socialIcons.map((icon) => (
                <Link className="__social-link" key={icon.id} children={icon.icon} href={icon.link} isExternal />
              ))}
            </div>
          </div>
          <div className="__vc-logo__wrapper">
            <LinkBox as="div">
              <LinkOverlay href="https://usa.visotsky.com/" isExternal>
                <Image className="__vc-logo" src="/images/VC_logo.png" />
              </LinkOverlay>
            </LinkBox>
          </div>
        </div>
      </div>
    </div>
  );
}
